const CANONICAL_ORIGIN = "https://www.cosmetic.college";
const SITE_NAME = "Cosmetic College";
const DEFAULT_OG_IMAGE = `${CANONICAL_ORIGIN}/logo/cosmetic-college-logo.png`;

const NOINDEX_META_VALUE = "noindex, nofollow";
const NOINDEX_FOLLOW_META_VALUE = "noindex, follow";
const NOINDEX_HEADER_VALUE = "noindex, nofollow, noarchive";

const INDEXATION_ROUTES = [
  { prefix: "/account", indexable: false },
  { prefix: "/book", indexable: false },
  { prefix: "/checkout", indexable: false },
  { prefix: "/confirm", indexable: false },
  { prefix: "/enroll", indexable: false },
  { prefix: "/enrolment", indexable: false },
  { prefix: "/enrollment/quote", indexable: false },
  { prefix: "/feedback", indexable: false },
  { prefix: "/forms", indexable: false },
  { prefix: "/forgot-password", indexable: false },
  { prefix: "/intro", indexable: false },
  { prefix: "/model", indexable: false },
  { prefix: "/models/checkout", indexable: false },
  { prefix: "/model-onboard", indexable: false },
  { prefix: "/onboard", indexable: false },
  { prefix: "/online/enrolment", indexable: false },
  { prefix: "/october-promotions", indexable: false },
  { prefix: "/reset-password", indexable: false },
  { prefix: "/set-password", indexable: false },
  { prefix: "/sign-in", indexable: false },
  { prefix: "/sign-up", indexable: false },
  { prefix: "/thanks", indexable: false },
  { prefix: "/uploads", indexable: false },
  { prefix: "/v1", indexable: false },
  // Campaign / utility pages (noindex, follow)
  {
    // Keep noindex,follow for robots. Batch 18: exclude from sitemap.
    prefix: "/last-minute-offers",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
    includeInSitemap: false,
  },
  {
    prefix: "/summer-sponsorship",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  { prefix: "/sms", indexable: false, robots: NOINDEX_FOLLOW_META_VALUE },
  {
    prefix: "/christmas-present",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/black-friday",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/early-bird-offers",
    indexable: false,
  },
  {
    prefix: "/end-of-summer-sale",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/best-aesthetic-course-for-you/result",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/calls/advisor",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/calls/support",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  // Brief 05 §8: thin search UI should not be indexed
  {
    prefix: "/course-search",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  // Ghost SKU (308s to L4 skin certificate)
  {
    prefix: "/courses/vtct/level-4-diploma-in-advanced-aesthetic-treatments",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  // Batch 7: redirected course pages (excluded from sitemap)
  {
    prefix: "/courses/vtct/vtct-level-3-award-in-first-aid-at-work",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  {
    prefix: "/courses/vtct/level-4-micropigmentation-conversion-training-course",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
  // Sellout booking funnels: noindex and canonical to /2026-dates/.
  {
    prefix: "/2026-dates/book",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  },
];

// Once the destination and lead handover have been approved, the legacy
// business URL is both redirected and removed from generated sitemap output.
if (process.env.ENABLE_BUSINESS_TRAINING_REDIRECT === "true") {
  INDEXATION_ROUTES.push({
    prefix: "/for-business",
    indexable: false,
    robots: NOINDEX_FOLLOW_META_VALUE,
  });
}

const SITEMAP_EXCLUDED_PATH_PREFIXES = INDEXATION_ROUTES.filter(
  (x) => !x.indexable && !x.includeInSitemap
).map((x) => x.prefix);

module.exports = {
  CANONICAL_ORIGIN,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
  NOINDEX_META_VALUE,
  NOINDEX_FOLLOW_META_VALUE,
  NOINDEX_HEADER_VALUE,
  INDEXATION_ROUTES,
  SITEMAP_EXCLUDED_PATH_PREFIXES,
};
